<div class="number-control" [ngClass]="{ clear: !showButtons }">
  <craft-icon
    *ngIf="showButtons"
    name="components--radio-minus-off-md"
    class="control minus"
    [ngClass]="{ disabled: $any(val) <= min! }"
    (click)="minus()"
  >
  </craft-icon>

  <input
    type="text"
    maxlength="16"
    class="input"
    numbersOnly
    #input
    [allowNull]="allowNull"
    [min]="min"
    [max]="max"
    [value]="val"
    [placeholder]="placeholder"
    (blur)="onBlur(input.value)"
  />

  <craft-icon
    *ngIf="showButtons"
    name="components--radio-add-off-md"
    class="control plus"
    [ngClass]="{ disabled: $any(val) >= max! }"
    (click)="plus()"
  >
  </craft-icon>
</div>
